function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useMemo, useState, useCallback, useDebugValue } from 'react';
import createMediaQueries from './createMediaQueries.js';
import useIsomorphicEffect from './useIsomorphicEffect.js';
var EMPTY_BREAKPOINT = {
  breakpoint: undefined,
  minWidth: undefined,
  maxWidth: undefined
};
/**
 * A React hook to use the current responsive breakpoint.
 * Will listen to changes using the window.matchMedia API.
 * @param {*} config the list of configured breakpoint names and their pixel values
 * @param {*} [defaultBreakpoint] the optional default breakpoint
 * @param {*} [hydrateInitial] whether to return the default breakpoint on first render. Set to `false` if the real breakpoint should be returned instead. Only applies to the browser, not server-side.
 *
 * @example
 * const breakpoints = { mobile: 0, tablet: 768, desktop: 1280 }
 * ...
 * const result = useBreakpoint(breakpoints)
 * // { breakpoint: string; minWidth: number; maxWidth: number | null } | { breakpoint: undefined; minWidth: undefined; maxWidth: undefined }
 *
 * @example <caption>With default value</caption>
 * const breakpoints = { mobile: 0, tablet: 768, desktop: 1280 }
 * ...
 * const result = useBreakpoint(breakpoints, 'mobile')
 * // breakpoint: { breakpoint: string; minWidth: number; maxWidth: number | null }
 *
 * @example <caption>With default value, but not hydrated. This means the breakpoint might be different on the initial render.</caption>
 * const breakpoints = { mobile: 0, tablet: 768, desktop: 1280 }
 * ...
 * const result = useBreakpoint(breakpoints, 'mobile', false)
 * // breakpoint: { breakpoint: string; minWidth: number; maxWidth: number | null }
 */

var useBreakpoint = function useBreakpoint(config, defaultBreakpoint) {
  var hydrateInitial = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  /** Memoize list of calculated media queries from config */
  var mediaQueries = useMemo(function () {
    return createMediaQueries(config);
  }, [config]);
  /** Get initial breakpoint value */

  var _useState = useState(function () {
    /** Loop through all media queries */
    var _iterator = _createForOfIteratorHelper(mediaQueries),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _ref2 = _step.value;
        var query = _ref2.query;

        var breakpoint = _objectWithoutProperties(_ref2, ["query"]);

        /**
         * If we're in the browser and there's no default value,
         * try to match actual breakpoint. If the default value
         * should not be hydrated, use the actual breakpoint.
         */
        if (typeof window !== 'undefined' && !(defaultBreakpoint && hydrateInitial)) {
          var mediaQuery = window.matchMedia(query);

          if (mediaQuery.matches) {
            return breakpoint;
          }
        } else if (breakpoint.breakpoint === defaultBreakpoint) {
          /** Otherwise, try to match default value */
          return breakpoint;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return EMPTY_BREAKPOINT;
  }),
      _useState2 = _slicedToArray(_useState, 2),
      currentBreakpoint = _useState2[0],
      setCurrentBreakpoint = _useState2[1];
  /** If there's a match, update the current breakpoint */


  var updateBreakpoint = useCallback(function (_ref3, breakpoint) {
    var matches = _ref3.matches;

    if (matches) {
      setCurrentBreakpoint(breakpoint);
    }
  }, []);
  /** On changes to mediaQueries, subscribe to changes using window.matchMedia */

  useIsomorphicEffect(function () {
    var unsubscribers = mediaQueries.map(function (_ref4) {
      var query = _ref4.query,
          breakpoint = _objectWithoutProperties(_ref4, ["query"]);

      var list = window.matchMedia(query);
      updateBreakpoint(list, breakpoint);

      var handleChange = function handleChange(event) {
        updateBreakpoint(event, breakpoint);
      };

      list.addListener(handleChange);
      /** Map the unsubscribers array to a list of unsubscriber methods */

      return function () {
        return list.removeListener(handleChange);
      };
    });
    /** Return a function that when called, will call all unsubscribers */

    return function () {
      return unsubscribers.forEach(function (unsubscriber) {
        return unsubscriber();
      });
    };
  }, [mediaQueries, updateBreakpoint]);
  /** Print a nice debug value for React Devtools */

  useDebugValue(currentBreakpoint, function (c) {
    return typeof c.breakpoint === 'string' ? "".concat(c.breakpoint, " (").concat(c.minWidth, " \u2264 x").concat(c.maxWidth ? " < ".concat(c.maxWidth + 1) : '', ")") : '';
  });
  return currentBreakpoint;
};

export default useBreakpoint;